import React from 'react'

export default function Page404() {

    return (
        <>
            <p>KHÔNG TÌM THẤY MÃ GIAO DỊCH</p>
        </>
    )
}